import React from "react";
import { X, Check, ArrowRight } from "lucide-react";
import { getServiceIcon, getAccent } from "@/lib/serviceIcons";

const badgeCls = {
  managed: "badge-managed", ai: "badge-ai", automation: "badge-auto",
  "self-serve": "badge-self", "pre-made": "badge-pre",
};

export default function InfoModal({ open, onClose, service, onViewPage, onAdd }) {
  if (!open || !service) return null;
  const Icon = getServiceIcon(service.icon);
  const accent = getAccent(service.accent);

  return (
    <div className="fixed inset-0 z-[160] flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
      <div className="glass-panel bg-[#0a0a0b]/95 rounded-3xl shadow-2xl w-full max-w-lg relative fade-in overflow-hidden border border-white/10">
        <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/5 text-zinc-400 hover:text-white hover:bg-white/10 transition-colors z-10"><X size={16} /></button>
        <div className="p-8">
          <div className={`w-16 h-16 rounded-2xl mb-6 flex items-center justify-center border ${accent.bg} ${accent.text} ${accent.border}`}>
            <Icon size={28} />
          </div>
          <h3 className="text-2xl font-bold text-white mb-2 tracking-tight">{service.title}</h3>
          <span className={`inline-block px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider mb-6 ${badgeCls[service.type] || "badge-self"}`}>{service.badge}</span>
          <p className="text-zinc-400 text-sm leading-relaxed mb-6">{service.long_desc}</p>
          <div className="bg-black/40 rounded-xl p-4 border border-white/5 mb-8">
            <h4 className="text-xs font-bold text-white uppercase tracking-wider mb-3">Core Features</h4>
            <ul className="space-y-2 text-sm text-zinc-300">
              {(service.features || []).slice(0, 4).map((f) => (
                <li key={f} className="flex items-center gap-2"><Check size={15} className="text-green-400 flex-shrink-0" /> {f}</li>
              ))}
            </ul>
          </div>
          <div className="flex gap-4">
            <button onClick={onViewPage} className="flex-1 px-4 py-3 border border-white/10 text-white rounded-xl font-bold hover:bg-white/5 transition-colors flex items-center justify-center">View Full Page <ArrowRight size={16} className="ml-2" /></button>
            <button onClick={onAdd} className="flex-1 px-4 py-3 bg-white text-black rounded-xl font-bold hover:bg-zinc-200 transition-colors shadow-[0_0_15px_rgba(255,255,255,0.2)]">Add to Profile</button>
          </div>
        </div>
      </div>
    </div>
  );
}
